import { supabase } from '../lib/supabase';

export async function fetchWorkflowActionDefinitions() {
  const { data, error } = await supabase
    .from('workflow_action_definitions')
    .select('*')
    .eq('is_active', true)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data || [];
}

export async function fetchMilestoneTemplateActionsByMilestoneIds(milestoneIds) {
  if (!milestoneIds?.length) return [];
  const { data, error } = await supabase
    .from('milestone_template_actions')
    .select('*')
    .in('milestone_template_id', milestoneIds);
  if (error) throw error;
  return data || [];
}

export async function fetchMilestoneTemplateActionsForMilestone(milestoneTemplateId) {
  if (!milestoneTemplateId) return [];
  const { data, error } = await supabase
    .from('milestone_template_actions')
    .select('*')
    .eq('milestone_template_id', milestoneTemplateId)
    .order('sort_order', { ascending: true });
  if (error) throw error;
  return data || [];
}

/**
 * Replace all bindings for a milestone template with the given rows.
 * Each row: { action_key, sort_order, allowed_role_types, config }
 */
export async function replaceMilestoneTemplateActions(milestoneTemplateId, rows) {
  const { error: delError } = await supabase
    .from('milestone_template_actions')
    .delete()
    .eq('milestone_template_id', milestoneTemplateId);
  if (delError) throw delError;

  if (!rows?.length) return;

  const payload = rows.map((r, i) => ({
    milestone_template_id: milestoneTemplateId,
    action_key: r.action_key,
    sort_order: r.sort_order ?? i,
    allowed_role_types: r.allowed_role_types || ['administrator'],
    config: r.config || {},
  }));

  const { error: insError } = await supabase.from('milestone_template_actions').insert(payload);
  if (insError) throw insError;
}
